<template>
  <div>
    <section class='login'>
      <div class="flex-wrapper">
        <div class="content">
          <div class="content-wrap">
            <div class="group">
              <router-link
                  class="menu-link"
                  :to="{name: 'public.login'}"
              >
                <img :src="logo" alt="Broodje dunner logo">
              </router-link>
            </div>

            <div class='group'>
              <h3>Wachtwoord vergeten</h3>
            </div>

            <div class='group'>
              <p class="light">Vul hieronder je e-mailadres in en we sturen je een link om jouw wachtwoord te resetten.</p>

              <ResetPasswordForm/>
            </div>

            <router-link
                :to='{name: "public.login"}'
                class='underline'
            >
              Terug naar inlogscherm
            </router-link>
          </div>
        </div>

        <div class="image">
          <img :src="image" alt="Login image for Broodje Dunner">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ResetPasswordForm from "@/components/blocks/ResetPasswordForm.vue";
import background from "@/assets/images/login-background.jpeg";
import logo from "@/assets/images/logo.svg";

export default {
  name: "PasswordReset",
  data() {
    return {
      image: background,
      logo: logo
    }
  },
  components: {
    ResetPasswordForm,
  },
};
</script>
